import type { ReactNode } from 'react'
import { useState } from 'react'
import cx from 'helpers/cx'
import { useTabletDown } from 'helpers/useMediaQuery'

import { ChevronRightIcon } from '@pleio/icons/chevron-right'

import Card, { CardContent } from 'js/components/Card'
import { H3 } from 'js/components/Heading'

import styles from './Accordeon.module.css'

export interface Props {
    title: string
    children: ReactNode
}

const Accordeon = ({ title, children }: Props) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleOpen = () => {
        setIsOpen(!isOpen)
    }

    return useTabletDown() ? (
        <div className={cx('card', styles.wrapper, isOpen && styles.isOpen)}>
            <div className="card__content">
                <button style={{ width: '100%' }} onClick={toggleOpen}>
                    <H3 as="h2">{title}</H3>
                    <ChevronRightIcon />
                </button>
                {isOpen && (
                    <div data-accordion-content>
                        <div>{children}</div>
                    </div>
                )}
            </div>
        </div>
    ) : (
        <Card style={{ marginBottom: '20px' }}>
            <CardContent>
                <H3 as="h2" style={{ marginBottom: '8px' }}>
                    {title}
                </H3>
                {children}
            </CardContent>
        </Card>
    )
}

export default Accordeon
